var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 9.58333C31.7252 9.58333 32.5833 8.72521 32.5833 7.66667C32.5833 6.60812 31.7252 5.75 30.6667 5.75C29.6081 5.75 28.75 6.60812 28.75 7.66667C28.75 8.72521 29.6081 9.58333 30.6667 9.58333Z",
    fill: "#AD4D34",
    stroke: "#AD4D34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 36.4167L36.4166 23L24.9166 24.9167M9.5833 15.3333L15.3333 9.58333L25.875 15.3333L21.3516 22.0417M8.12663 27.7917C7.58582 29.5609 7.56865 31.4488 8.0772 33.2275C8.58576 35.0063 9.59829 36.5998 10.9926 37.8157C12.3869 39.0317 14.1033 39.8181 15.9347 40.08C17.766 40.3419 19.6341 40.0681 21.3133 39.2917",
    stroke: "#AD4D34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3732 33.5417C26.914 31.7725 26.9312 29.8845 26.4226 28.1058C25.9141 26.3271 24.9015 24.7335 23.5072 23.5176C22.113 22.3016 20.3965 21.5153 18.5652 21.2534C16.7338 20.9915 14.8657 21.2653 13.1865 22.0417",
    stroke: "#AD4D34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibilityIcon);
export default __webpack_public_path__ + "static/media/accessibilityIcon.a67c52d43b651c1700d521bd2c6b7eef.svg";
export { ForwardRef as ReactComponent };